/** @jsxImportSource @emotion/react */

import styles from './styles';

export interface TeamAssignmentItemProps {
    color: string;
    text: string;
    colorScheme: string;
}

export function TeamAssignmentItem({ text, color, colorScheme }: TeamAssignmentItemProps) {
    return <div css={styles.teamBoxColor({ teamColor: color, colorScheme })}>{text}</div>;
}
